import React from 'react'

import { Products } from '@peracto/peracto-blocks-tailwind'
import Form from './Form/ProductsForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }

    const RenderComponent = Products

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/products',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            numberOfProducts: 4,
            category: '',
            sku: '',
            fallbackImage: '',
            multiple: true,
        }),
    }
}

export default createPlugin
